import { runInAction } from 'mobx';
import ParametroUsuarioApi from '../api/ParametroUsuarioApi';
import { IParametrosUsuario } from '../modelo/Parametros';
import ParametroUsuarioStore from '../store/ParametroUsuarioStore';

class ParametroUsuarioService {

    private readonly parametrosEsperados = {
        filtro: [
            'assinatura', 'relator', 'unidadePublicadora', 'correJuntoAssociado',
            'tiposPeticoesPendentes', 'votoLiberado'
        ],
        icone: [
            'ge', 'atualizarDados', 'copiarNumero', 'resumoAguia', 'inteiroTeor',
            'peticoesPendentes', 'retornoGabinete', 'impedimento',
            'relatorOriginal', 'associado', 'correJunto'
        ]
    };

    async inicializarParametroStore() {
        const parametrosUsuario = await this.todosParametros();

        runInAction(() => {
            ParametroUsuarioStore.parametros = parametrosUsuario || [];
            ParametroUsuarioStore.parametrosFiltro = [];
            ParametroUsuarioStore.parametrosColuna = [];
            ParametroUsuarioStore.parametrosIcone = [];

            parametrosUsuario
                .filter(param => param.tipo === 'filtro')
                .forEach(param => ParametroUsuarioStore.parametrosFiltro[param.parametro + param.codTipoEscaninho] = param);

            parametrosUsuario
                .filter(param => param.tipo === 'coluna')
                .forEach(param => ParametroUsuarioStore.parametrosColuna[param.parametro + param.codTipoEscaninho] = param);

            parametrosUsuario
                .filter(param => param.tipo === 'icone')
                .forEach(param => ParametroUsuarioStore.parametrosIcone[param.parametro + param.codTipoEscaninho] = param);

            const parametroSigla = parametrosUsuario.find(p => p.tipo === 'sigla');

            if (parametroSigla) {
                ParametroUsuarioStore.siglaSalva = parametroSigla.parametro || "";
                ParametroUsuarioStore.sigla = "";
                ParametroUsuarioStore.exibirDialogSigla = false;
            } else {
                ParametroUsuarioStore.siglaSalva = null;
                ParametroUsuarioStore.sigla = "";
                ParametroUsuarioStore.exibirDialogSigla = true;
            }
        });
    }

    async salvar(parametro: IParametrosUsuario) {
        return await ParametroUsuarioApi.salvar(parametro);
    }

    async excluir(parametro: IParametrosUsuario) {
        return await ParametroUsuarioApi.excluir(parametro);
    }

    async todosParametros(): Promise<IParametrosUsuario[]> {
        let result = await ParametroUsuarioApi.todosParametros();

        const tiposEscaninhoConfiguraveis = [1, 2];
        const faltamParametros = !result.length || Object.entries(this.parametrosEsperados).some(([tipo, parametros]) =>
            parametros.some(parametro => tiposEscaninhoConfiguraveis.some(codTipoEscaninho =>
                !result.some(item => item.tipo === tipo
                    && item.parametro === parametro
                    && item.codTipoEscaninho === codTipoEscaninho)
            ))
        );

        if (faltamParametros) {
            await this.criarPadrao();
            result = await ParametroUsuarioApi.todosParametros();

            runInAction(() => {
                ParametroUsuarioStore.parametros = result;
            });
        }
        return result;
    }

    async criarPadrao(): Promise<IParametrosUsuario[] | any> {
        return await ParametroUsuarioApi.criarPadrao()
    }

    async salvarSigla(sigla: string) {
        return await ParametroUsuarioApi.salvarSigla(sigla);
    }
}

export default new ParametroUsuarioService();
